import {Action} from "@ngrx/store";
import {HostingLogData} from '../../websites/website/hosting/logs/hostingLogData';

export const LOAD_LOGS: string = '[log] Load Logs';
export const LOAD_LOGS_SUCCESS: string = '[log] Load Logs Success';
export const LOAD_LOGS_FAIL: string = '[log] Load Logs Fail';

export class LoadLogs implements Action {
  readonly type: string = LOAD_LOGS;
  constructor(public payload: number, public lines: number, public logType: string) {}
}

export class LoadLogsSuccess implements Action {

  readonly type: string = LOAD_LOGS_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    entities: {[websiteId: number]: HostingLogData},
  }) {}

}

export class LoadLogsFail implements Action {

  readonly type: string = LOAD_LOGS_FAIL;
  constructor(public payload: string) {}

}


export type LogAction = LoadLogs | LoadLogsSuccess | LoadLogsFail;
